import type { SerializableBlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { isTemplateExport } from "@circle-react-shared/BuilderUI/Helpers/typePredicates";
import { ComponentPreview } from "./ComponentPreview";
import { TemplatePreview } from "./TemplatePreview";

export interface BlockPreviewCardProps {
  block: SerializableBlockExport;
  isElementType?: boolean;
  isOverlay?: boolean;
}

export const BlockPreview = ({
  block,
  isElementType = false,
  isOverlay = false,
}: BlockPreviewCardProps) => {
  if (isTemplateExport(block)) {
    return (
      <TemplatePreview
        isElementType={isElementType}
        block={block}
        isOverlay={isOverlay}
      />
    );
  }

  return (
    <ComponentPreview
      isElementType={isElementType}
      block={block}
      isOverlay={isOverlay}
    />
  );
};
